import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from './templates/interactive.jsx';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };

        return this;
    }

    static displayName = 'Transfers';

    static contextTypes = {
        app: PropTypes.object
    };
}
